
































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Meeting } from "@api/models/meetings/Meeting";
import { Element } from "@api/models/Element";
import { UserProfile } from "@api/models/UserProfile";
import Presentation from "@share/presentation/Presentation.vue";
import MediaLibrary from "@share/web-conferences/components/media-library/MediaLibrary.vue";
import AutoplayError from "@share/web-conferences/components/AutoplayError.vue";
import CantJoin from "@share/web-conferences/components/CantJoin.vue";
import Connecting from "@share/web-conferences/components/Connecting.vue";
import ControlPanel from "@share/web-conferences/components/control-panel/ControlPanel.vue";
import DevicesTest from "@share/web-conferences/components/devices-test/DevicesTest.vue";
import StoppedScreen from "@share/web-conferences/components/StoppedScreen.vue";
import Stage from "@share/web-conferences/components/Stage.vue";
import VideoStream from "@share/web-conferences/components/VideoStream.vue";
import BackgroundSelectModal from "@share/web-conferences/components/background-select/BackgroundSelectModal.vue";
import { WebConferenceService } from "@share/web-conferences/data/WebConferenceService";
import { AgoraScreenShare } from "@share/web-conferences/agora/AgoraScreenShare";
import { UserProfilesService } from "@share/web-conferences/data/UserProfilesService";
import { JoinHandler } from "@share/web-conferences/agora/JoinHandler";
import { AgoraConnectionStateInterface } from "@share/web-conferences/interfaces/AgoraConnectionStateInterface";
import { ConnectionDropHandler } from "@share/web-conferences/agora/ConnectionDropHandler";
import { TokenExpirationHandler } from "@share/web-conferences/agora/TokenExpirationHandler";
import { SpeakerChecker } from "@share/web-conferences/helpers/SpeakerChecker";
import { WebConferenceStateHelper } from "@share/web-conferences/helpers/WebConferenceStateHelper";
import { SignalRHelper } from "@share/web-conferences/signal-r/SignalRHelper";
import { RecordingStatusObserver } from "@share/web-conferences/signal-r/observers/RecordingStatusObserver";
import { GlobalEvents, GlobalEventTypes } from "@share/web-conferences/helpers/GlobalEvents";
import { ObserverData } from "@share/web-conferences/interfaces/signalr/ObserverData";
import { StoreHelper } from "@share/web-conferences/helpers/StoreHelper";
import { SchemaId } from "@api/enums/SchemaId";
import { sessionHasStopped, sessionStarted } from "@share/web-conferences/helpers/OnlineStateHelper";
import { isPresenter } from "@share/web-conferences/helpers/UserRoleHelper";
import { isSchemaMeeting } from "@share/web-conferences/helpers/isSchemaMeeting";
import { fireInitializedEvent } from "@share/web-conferences/helpers/EventBusHelper";
import { addJoinedUserAction, cleanWebConferenceAction, setStateHelper } from "@share/web-conferences/store/actions";
import { WebConferenceRepository } from "@api/repositories/WebConferenceRepository";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { AgoraRemoteUsers } from "@share/web-conferences/agora/AgoraRemoteUsers";
import { TracksManager } from "@share/web-conferences/agora/TracksManager";
import { AgoraVolumesManager } from "@share/web-conferences/agora/AgoraVolumesManager";
import { AgoraNetworkQuality } from "@share/web-conferences/agora/AgoraNetworkQuality";
import { conferenceType } from "@share/web-conferences/helpers/ConferenceType";
import { AgoraConnectionState } from "@share/web-conferences/agora/AgoraConnectionState";
import { PresenterObserver } from "@share/web-conferences/signal-r/observers/PresenterObserver";
import { UserHandObserver } from "@share/web-conferences/signal-r/observers/UserHandObserver";
import { StreamStatusChangeObserver } from "@share/web-conferences/signal-r/observers/StreamStatusChangeObserver";
import { SignalRObserver } from "@share/web-conferences/interfaces/signalr/SignalRObserver";
import {
    CurrentPresentationUpdatedObserver
} from "@share/web-conferences/signal-r/observers/CurrentPresentationUpdatedObserver";
import { AgoraInterface } from "@share/web-conferences/interfaces/AgoraInterface";
import { DevicesInfo } from "@share/web-conferences/types/DevicesInfo";
import { UserRoleType } from "@share/web-conferences/enums/UserRoleType";
import { isFinished } from "@common/webinarHelper";
import { recordingStartedGetter } from "@share/web-conferences/store/getters";
import { sendRecordingNotification } from "@share/web-conferences/helpers/recordings/NotificationSender";
import { RecordingStatuses } from "@share/web-conferences/enums/RecordingStatuses";
import { Agora } from "@share/web-conferences/agora/Agora";
import { stateKey } from "@share/web-conferences/helpers/StateKey";
import { RecordingController } from "@share/web-conferences/helpers/RecordingController";
import { AgoraCloudProxy } from "@share/web-conferences/agora/AgoraCloudProxy";
import { AgoraVirtualBackground } from "./agora/AgoraVirtualBackground";
import { VirtualBackgroundEffectOptions } from "agora-extension-virtual-background";
import { ILocalVideoTrack } from "agora-rtc-sdk-ng";
import { AgoraVirtualBackgroundEffect } from "./enums/AgoraVirtualBackgroundEffect";

@Component({
    name: "AgoraConference",
    components: {
        Presentation, BackgroundSelectModal,
        MediaLibrary, AutoplayError, CantJoin, Connecting, ControlPanel, DevicesTest, StoppedScreen, Stage, VideoStream
    }
})
export default class AgoraConference extends Vue {
    @Prop({ required: true }) schemaId: string;
    @Prop({ required: true }) element: Meeting | Element;
    @Prop({ default: () => [] }) speakers: UserProfile[];
    @Prop({ default: false }) hideControlPanel: boolean;
    @Prop() stateHelper: WebConferenceStateHelper;
    @Prop({ default: false }) showRecordingButton: boolean;

    showBackground = false;

    agora: Agora | null = null;
    webConferencesService: WebConferenceService | null = null;
    agoraShareClient: AgoraScreenShare | null = null;
    userProfilesService: UserProfilesService | null = null;
    joinHandler: JoinHandler | null = null;
    agoraConnectionState: AgoraConnectionStateInterface | null =null;
    connectionDropHandler: ConnectionDropHandler | null = null;
    tokenExpirationHandler: TokenExpirationHandler | null = null;
    speakerChecker: SpeakerChecker | null = null;
    signalRHelper: SignalRHelper | null = null;
    recordingStatusObserver: RecordingStatusObserver | null = null;
    globalEvents: GlobalEvents = new GlobalEvents();
    observersData: ObserverData | null = null;
    agoraCloudProxy: AgoraCloudProxy | null = null;
    stateKey = '';
    showLibrary = false;
    storeHelper: StoreHelper | null = null;
    recodingController: RecordingController | null = null;

    //background effects
    agoraVirtualBackground: AgoraVirtualBackground | null = null;
    backgroundEffect: VirtualBackgroundEffectOptions | null = null;

    handleBackgroundSelect(effectType: VirtualBackgroundEffectOptions | null) {
        if (this.backgroundEffect === effectType && this.agoraVirtualBackground?.hasTrack) {
            return;
        }

        this.backgroundEffect = effectType;
        this.applyBackgroundEffect(this.backgroundEffect);
    }

    //TODO: this logic need to be moved in Agora.ts
    /**
     * it might be while device test
     * and when user joined to conference
     * @param effectType
     * @param resetTrack - set new track to @AgoraVirtualBackground or set null instead track
     * it need for ability appling effect once after camera enabling
     */
    async applyBackgroundEffect(effectType: VirtualBackgroundEffectOptions | null, resetTrack = false) {

        let videoTrack = null;

        if (!this.agoraVirtualBackground || !this.agoraVirtualBackground.hasTrack || resetTrack) {
            //DEVICETEST:
            const deviceTestComponent = this.$refs["deviceTest"] as DevicesTest | undefined;
            videoTrack = deviceTestComponent?.videoTrack;

            // STAGE:
            if (!videoTrack && this.stateHelper.showPlayer && !this.stateHelper.left) {
                videoTrack = this.agora?.tracksManager.getLocalUserTracks()?.video as ILocalVideoTrack | undefined;
            }

            if (!this.agoraVirtualBackground && videoTrack) {
                const VirtualBackgroundExtension = (await import(/* webpackChunkName: "virtualbackground" */"agora-extension-virtual-background")).default;
                this.agoraVirtualBackground = new AgoraVirtualBackground(new VirtualBackgroundExtension(), videoTrack);
                this.agora?.setAgoraVirtualBackground(this.agoraVirtualBackground);
            }

            if ((videoTrack && !this.agoraVirtualBackground?.hasTrack) || resetTrack) {
                await this.agoraVirtualBackground?.resetTrack(videoTrack || null);
            }
        }

        if (this.agoraVirtualBackground?.hasTrack) {
            this.agoraVirtualBackground?.applyEffect(effectType);
        }
    }

    /**
     * Apply effect only if @AgoraVirtualBackground doesn't have videoTrack
     * It need for applying effect after camera enabling if it was joining without camera
     * @param effectType
     */
    applyBackgroundEffectOnce(effectType: VirtualBackgroundEffectOptions | null) {
        if (!this.agoraVirtualBackground?.hasTrack) {
            this.applyBackgroundEffect(effectType, true);
        }
    }

    changeVideoDevice() {
        this.agoraVirtualBackground && this.applyBackgroundEffect(this.backgroundEffect, true);
    }

    get tracks() {
        return this.agora?.tracksManager.tracks ?? {};
    }

    get volumes() {
        return this.agora?.volumesManager.list ?? {};
    }

    get isReconnecting() {
        return this.agoraConnectionState?.isReconnecting || this.connectionDropHandler?.isReconnecting;
    }

    get lang() {
        return this.$store.state.session?.language ?? 'en';
    }

    get isAdmin() {
        return this.$store.getters.isAdmin;
    }

    get userId() {
        return this.$store.state.session.userId;
    }

    get currentUserProfile(): UserProfile {
        return this.$store.getters.profile;
    }

    get isCurrentUserInSpeakersList() {
        return this.currentUserProfile && this.speakerChecker?.isInOriginalSpeakersList(this.currentUserProfile.userId as number);
    }

    get showControlPanel() {
        return !this.stateHelper.left && this.agora && this.agora.joined && !this.hideControlPanel;
    }

    get needHandRaiseButton() {
        return this.schemaId !== SchemaId.meetingsSchedule
    }

    get needLiveSwitcher() {
        return this.schemaId === SchemaId.meetingsSchedule && this.isAdmin
    }

    @Watch('element', {deep: true})
    onElementChange() {
        if (sessionHasStopped(this.element)) {
            this.stateHelper.stopped = true;

            if (this.webConferencesService?.webConferenceData?.userRole && !isPresenter(this.webConferencesService?.webConferenceData?.userRole)) {
                this.onLeave(false);
            }
            return;
        }

        if (sessionStarted(this.element)) {
            this.stateHelper.started = true;
            this.stateHelper.showEventInfo = false;

            if (!this.joinHandler?.agora.joined && !this.stateHelper.connecting) {
                this.stateHelper.needDeviceTest = this.speakerChecker?.isSpeaker(this.currentUserProfile.userId as number) || false;
                if (!this.stateHelper.needDeviceTest) {
                    this.join();
                }
            }
            return;
        }
    }

    @Watch('stateHelper.banned')
    watchAgoraJoined(banned: boolean) {
        if(banned) {
            this.$emit('leave');
        }
    }

    async mounted() {
        await this.init();

        this.stateHelper.started = sessionStarted(this.element);
        this.stateHelper.stopped = sessionHasStopped(this.element);

        await this.signalRHelper?.connectToHub();

        const isSpeaker = this.speakerChecker?.isSpeaker(this.currentUserProfile.userId as number);

        if (isSpeaker || this.isAdmin || this.stateHelper.isActive) {
            this.stateHelper.needDeviceTest = isSpeaker || false;
            if (!this.stateHelper.needDeviceTest) {
                await this.join();
            }

            this.recordingStatusObserver?.setShouldReact(true);
        }
        else {
            this.stateHelper.showEventInfo = !this.stateHelper.stopped;
            this.stateHelper.left = this.stateHelper.stopped;
        }

        this.$emit('initialized', { agora: this.agora, userProfilesService: this.userProfilesService });

        fireInitializedEvent(this.schemaId, this.element.id);

        this.stateHelper.initialized = true;
    }

    async join() {
        if (this.stateHelper.connecting) {
            return;
        }

        this.stateHelper.showEventInfo = false;
        this.stateHelper.left = false;

        this.stateHelper.connecting = true;

        if (this.agora?.joined) {
            await this.agora.changeRoleToHost();

            if (this.webConferencesService?.webConferenceData?.sharingCredentialsEmpty()) {
                await this.webConferencesService?.join();
            }
        }
        else {
            await this.joinHandler?.join();

            const joinedSuccessfully = !this.joinHandler?.cantJoin && this.webConferencesService?.isWebConferenceDataNotEmpty();

            if (joinedSuccessfully) {
                this.userProfilesService?.setProfile(this.currentUserProfile);
                this.webConferencesService?.webConferenceData?.isPresenter() && await this.agora?.createLocalTracks();
                this.$store.dispatch(addJoinedUserAction, {
                    userId: this.webConferencesService?.webConferenceData?.userId() as number,
                    key: this.stateKey
                })

                this.$emit("joined", true);
            }
            else {
                this.$emit("joined", false)
            }
        }

        //apply effects after join
        //reset track (it might me null if camera was off)
        this.applyBackgroundEffect(this.backgroundEffect, true);

        this.stateHelper.connecting = false;
    }

    removeAutoplayError() {
        if(this.agora) {
            this.agora.tracksManager.unmuteAll();
            Vue.set(this.agora.tracksManager, "isAutoPlayError", false);
        }
    }

    async init(): Promise<void> {
        this.storeHelper = new StoreHelper(this.$store, this.schemaId, this.element.id);
        this.stateKey = stateKey(this.schemaId, this.element.id);
        this.globalEvents.attach(GlobalEventTypes.Join, this.join.bind(this));
        let webConferenceRepository = this.$repositories.get<WebConferenceRepository>(RepositoryFabric.WEB_CONFERENCE);
        this.webConferencesService = new WebConferenceService(
            webConferenceRepository,
            this.schemaId,
            this.element,
            this.storeHelper,
            this.globalEvents
        );
        this.userProfilesService = new UserProfilesService(this.$repositories.get(RepositoryFabric.USER));
        this.speakerChecker = new SpeakerChecker(this.storeHelper, this.speakers, this.schemaId, this.isAdmin, this.userId, this.$router, this.webConferencesService);
        this.agora = new Agora(
            new AgoraRemoteUsers(
                this.userProfilesService as UserProfilesService,
                this.speakerChecker,
                this.storeHelper,
                this.webConferencesService
            ),
            new TracksManager(),
            new AgoraVolumesManager(),
            new AgoraNetworkQuality(),
            // new AgoraStatistics(),
            conferenceType(this.schemaId),
            this.storeHelper
        );

        this.globalEvents.attach(GlobalEventTypes.LowerVideoQuality, this.agora.lowerQuality.bind(this.agora));
        this.globalEvents.attach(GlobalEventTypes.RaiseVideoQuality, this.agora.raiseQuality.bind(this.agora));

        this.agoraCloudProxy = new AgoraCloudProxy(this.agora);
        this.agoraShareClient = new AgoraScreenShare(this.agora.tracksManager, this.$store, conferenceType(this.schemaId));
        this.joinHandler = new JoinHandler(this.webConferencesService as WebConferenceService, this.agora, this.agoraShareClient);
        this.connectionDropHandler = new ConnectionDropHandler(this.joinHandler as JoinHandler);
        this.tokenExpirationHandler = new TokenExpirationHandler(this.joinHandler as JoinHandler)
        this.agoraConnectionState = new AgoraConnectionState(this.agora, this.globalEvents);
        this.recodingController = new RecordingController(this.schemaId, this.element, this.storeHelper, this.$repositories.get(RepositoryFabric.MEETING));
        this.recodingController.initShowRecordingButton(this.$router);

        this.observersData = {
            schemaId: this.schemaId,
            objectId: this.element.id,
            realtimeRepository: this.$repositories.get(RepositoryFabric.REALTIME),
            store: this.$store,
            stateKey: this.stateKey
        };

        this.recordingStatusObserver = new RecordingStatusObserver(this.observersData as ObserverData, this.recodingController, this.isAdmin);

        this.signalRHelper = new SignalRHelper(
            this.observersData,
            [
                new PresenterObserver(this.observersData, this.joinHandler, this.join.bind(this), this.stateHelper),
                new UserHandObserver(this.observersData),
                new StreamStatusChangeObserver(this.observersData, this.agora, this.agoraShareClient),
                this.recordingStatusObserver as SignalRObserver,
                new CurrentPresentationUpdatedObserver(this.observersData, this.webConferencesService)
            ]
        );

        this.agoraConnectionState?.subscribe();
        this.tokenExpirationHandler?.subscribe();
        //this.$store.dispatch(setAgoraAction, { key: this.stateKey, agora: this.agora } as SetAgoraParams);
        this.storeHelper.setAgora(this.agora as AgoraInterface);
        this.storeHelper.setTracksManager(this.agora.tracksManager);
        this.$store.dispatch(setStateHelper, this.stateHelper);
    }

    async onLeave(emitEvent = true) {
        await this.agoraShareClient?.leave();
        await this.agora?.leave();

        this.webConferencesService?.lowerHandIfRaised();

        this.stateHelper.left = true;

        if (this.webConferencesService?.webConferenceData?.isSharingUser(this.userId)) {
            await this.webConferencesService?.nullCurrentPresentation();
        }

        emitEvent && this.$emit('leave');
    }

    async onSwitchMic(state: boolean) {
        await this.agora?.switchMic(state);
    }

    async onSwitchVideo(state: boolean) {
        await this.agora?.switchVideo(state);

        if (state) {
            //need apply only once
            this.applyBackgroundEffectOnce(this.backgroundEffect);
        }
    }

    async onJoin(data: DevicesInfo) {
        this.agoraVirtualBackground?.unpipe();
        this.stateHelper.stopDeviceTest();
        this.agora?.setDevicesData(data);
        await this.join();
    }

    async onDecline() {
        this.stateHelper.stopDeviceTest();
        this.webConferencesService?.setNewRole(UserRoleType.Audience);
        //@todo check how removing from the presenters works when the backend is ready
        try {
            await this.webConferencesService?.webConferenceRepository
                .deletePresenter(this.schemaId, this.element.id, this.currentUserProfile.userId as number);
            if (!this.agora?.joined) {
                await this.join();
            }
        }
        catch (e) {
            this.$store.dispatch('reportError', e);
        }
    }

    didSessionStop(): boolean {
        return sessionHasStopped(this.element) || isFinished(this.element.endAt);
    }

    async destroyed() {
        await this.onLeave();
        this.agora?.clean();
        this.agoraShareClient?.leave();
        this.userProfilesService?.clean();
        this.signalRHelper?.disconnectFromHub();
        this.connectionDropHandler?.clean();
        this.globalEvents?.clean();
        this.agora?.clean();

        if (this.recordingStatusObserver?.shouldReact && this.$store.getters[recordingStartedGetter](this.stateKey) && this.didSessionStop()) {
            sendRecordingNotification(this.$store, RecordingStatuses.Ended);
        }

        this.$store.dispatch(cleanWebConferenceAction, this.stateKey);
    }
}

